import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Tooltip, OverlayTrigger } from 'react-bootstrap';

import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../../shared/components/VerbButton';

const UserProfileRow = (props) => {
    const { firstName, lastName, email, _id } = props.user;
    const { disabled, fontAwesomeIcon, handleClick, isSelected, dateKey, isRegisteredMemberTable, linkToEdit } = props;
    const dateToParse = props.user[dateKey] || props.user.createdOn;
    const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    const parsedDate = new Date(dateToParse).toLocaleDateString('en-US', dateOptions);
    const invitedDate = new Date(props.user?.invitedDateTime).toLocaleDateString('en-US', dateOptions);
    const checkOrSquare = isSelected ? 'fa-check-square' : 'fa-square';
    const useTrashcanIcon = isRegisteredMemberTable ? fontAwesomeIcon : checkOrSquare;

    // is current invited datetime within a minute of created datetime? if so, invitedDateTime is original invited date
    // and not a reminder
    const parsedInvitedDate = new Date(props.user?.invitedDateTime) - new Date(dateToParse) >= 60000 ? invitedDate : '';

    return (
        <tr>
            <td className={'button-cell'}>
                <VerbButton
                    buttonType={
                        isSelected ? VERB_BUTTON_TYPE.SECONDARY_DETAILS_SELECTED : VERB_BUTTON_TYPE.SECONDARY_DETAILS
                    }
                    disabled={disabled}
                    fontAwesomeIcon={useTrashcanIcon}
                    onClick={() => handleClick(props.user)}
                />
            </td>
            {isRegisteredMemberTable && (
                <td>
                    {linkToEdit ? (
                        <a href={`/edituserprofile/${_id}`}>{`${firstName || ''} ${lastName || ''}`}</a>
                    ) : (
                        `${firstName || ''} ${lastName || ''}`
                    )}
                </td>
            )}
            <td>{email}</td>
            <td>{parsedDate}</td>
            {!isRegisteredMemberTable && <td>{parsedInvitedDate}</td>}
        </tr>
    );
};

UserProfileRow.propTypes = {
    disabled: PropTypes.bool,
    fontAwesomeIcon: PropTypes.string,
    handleClick: PropTypes.func,
    isSelected: PropTypes.bool,
    user: PropTypes.shape({
        _id: PropTypes.string,
        updatedOn: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
        createdOn: PropTypes.string
    }),
    dateKey: PropTypes.string,
    isRegisteredMemberTable: PropTypes.bool,
    linkToEdit: PropTypes.bool
};

export class CompanyFormMemberTable extends Component {
    static propTypes = {
        memberProfiles: PropTypes.array,
        company: PropTypes.object,
        isUpdatingMembers: PropTypes.bool,
        deleteMember: PropTypes.func,
        fontAwesomeIcon: PropTypes.string,
        handleClick: PropTypes.func,
        selectedField: PropTypes.string,
        selectedList: PropTypes.array,
        actionTitle: PropTypes.string,
        dateTitle: PropTypes.string,
        dateKey: PropTypes.string,
        isRegisteredMemberTable: PropTypes.bool,
        areAllMembersSelected: PropTypes.bool,
        selectOrUnselectAllUnregisteredMember: PropTypes.func,
        linkToEditProfiles: PropTypes.bool
    };

    /**
     *
     * @param memberProfiles
     * @param company
     * @param isUpdatingMembers
     * @returns {Array}
     */

    getCurrentMembers = (memberProfiles, company, isUpdatingMembers) => {
        const {
            deleteMember,
            fontAwesomeIcon,
            handleClick,
            selectedList,
            selectedField,
            dateKey,
            isRegisteredMemberTable,
            linkToEditProfiles = false
        } = this.props;
        return memberProfiles.map(
            (user, index) =>
                user && (
                    <UserProfileRow
                        key={`${user._id}-${index}`}
                        deleteMember={deleteMember}
                        fontAwesomeIcon={fontAwesomeIcon}
                        disabled={isUpdatingMembers}
                        user={user}
                        handleClick={handleClick}
                        isRegisteredMemberTable={isRegisteredMemberTable}
                        isSelected={selectedList && selectedList.includes(user[selectedField])}
                        dateKey={dateKey}
                        linkToEdit={linkToEditProfiles}
                    />
                )
        );
    };

    render() {
        const {
            memberProfiles,
            company,
            isUpdatingMembers,
            actionTitle,
            dateTitle,
            areAllMembersSelected,
            selectOrUnselectAllUnregisteredMember,
            isRegisteredMemberTable = false
        } = this.props;

        const tooltip = (
            <Tooltip id={'tooltip'}>{areAllMembersSelected ? 'Unselect all members' : 'Select all members'}</Tooltip>
        );

        if (!memberProfiles || !memberProfiles.length) {
            return null;
        }

        return (
            <div className={'company-form-member-table col-sm-12'}>
                <Table responsive={true}>
                    <thead>
                        <tr>
                            {isRegisteredMemberTable && <th className={'adminAction'}>{actionTitle}</th>}
                            {!isRegisteredMemberTable && (
                                <OverlayTrigger placement={'left'} transition={false} overlay={tooltip} key={1}>
                                    <th className={'adminAction'}>
                                        <VerbButton
                                            buttonType={
                                                areAllMembersSelected
                                                    ? VERB_BUTTON_TYPE.SECONDARY_DETAILS_SELECTED
                                                    : VERB_BUTTON_TYPE.SECONDARY_DETAILS
                                            }
                                            fontAwesomeIcon={areAllMembersSelected ? 'fa-square' : 'fa-check-square'}
                                            onClick={() => selectOrUnselectAllUnregisteredMember()}
                                        />
                                    </th>
                                </OverlayTrigger>
                            )}
                            {isRegisteredMemberTable && <th>Name</th>}
                            <th>Email</th>
                            <th>{dateTitle}</th>
                            {!isRegisteredMemberTable && <th>Last Reminder Sent</th>}
                        </tr>
                    </thead>
                    <tbody>{this.getCurrentMembers(memberProfiles, company, isUpdatingMembers)}</tbody>
                </Table>
            </div>
        );
    }
}

export default CompanyFormMemberTable;
